/* eslint camelcase: 0 */
import { toTalkerProps } from './talker'
import { PutRoomRequest, Room, RoomRequest } from '@/infrastructure/network/Monitaro/schema/models'
import { IRoomProps, EmptyRoomPropsFactory } from '@/entities/Room'

export const toRoomProps = (props: Room | null | undefined): IRoomProps => {
  if (!props) {
    return EmptyRoomPropsFactory()
  }

  const {
    id,
    parent_id,
    owner,
    unread_count,
    users,
    doctors,
    parents,
    owner_id,
    owner_type,
    hospital_title,
    enabled,
    latest_at,
    properties,
    created_at,
    updated_at
  } = props

  return EmptyRoomPropsFactory({
    id,
    parentId: parent_id,
    owner,
    unreadCount: unread_count || 0,
    users: users?.map((props) => toTalkerProps(props, 'user')),
    doctors: doctors?.map((props) => toTalkerProps(props, 'doctor')),
    parents: parents?.map((props) => toTalkerProps(props, 'parent')),
    ownerId: owner_id,
    ownerType: owner_type,
    hospitalTitle: hospital_title,
    title: hospital_title?.title,
    enabled,
    latestAt: latest_at,
    properties,
    createdAt: created_at,
    updatedAt: updated_at
  })
}

export const toRoomRequest = (props: IRoomProps): RoomRequest => {
  const { title, talkers } = props
  return {
    title: title!,
    users: talkers?.filter((prop) => prop.type === 'user').map((prop) => prop.id!),
    doctors: talkers?.filter((prop) => prop.type === 'doctor').map((prop) => prop.id!)
  }
}

export const toPutRoomRequest = (props: IRoomProps): PutRoomRequest => {
  const { title, properties, talkers } = props
  return {
    title: title!,
    publish: properties?.publish,
    users: talkers?.filter((prop) => prop.type === 'user').map((prop) => prop.id!),
    doctors: talkers?.filter((prop) => prop.type === 'doctor').map((prop) => prop.id!)
  }
}
